/*
  Payday Sale guard for the Kasya AOV cart.

  Only when Shopify has applied one of the Payday automatic discounts
  (15% / 25% / 35% OFF PAYDAY SALE DISCOUNT) to the cart:
    - the progress bar stops filling at FREE SHIPPING
    - the ₱450 marker is faded and "₱450 OFF" is crossed out
    - once free shipping is reached, the text reads:
        FREE SHIPPING unlocked
        Payday Sale isn't stackable with ₱450 OFF
  Carts without a Payday discount keep the normal bar and text. After the
  Payday discounts end, no cart contains them, so nothing changes.

  Thresholds mirror `offers` in kasya-aov-cart.js.
*/
(function () {
  if (window.__paydayAovGuard) return;
  window.__paydayAovGuard = true;

  var FREE_SHIPPING_CENTS = 200000;
  var DISCOUNT_CENTS = 300000;
  var KEYWORD = 'payday';
  var HEADLINE = 'FREE SHIPPING unlocked';
  var NOTE = 'Payday Sale isn\u2019t stackable with \u20b1450 OFF';

  var style = document.createElement('style');
  style.textContent = [
    '.kasya-aov-cart--payday-applied .kasya-aov-cart__shipping-milestone--discount { animation: none !important; opacity: .35; }',
    '.kasya-aov-cart--payday-applied .kasya-aov-cart__shipping-label--discount { opacity: .5; text-decoration: line-through; }',
    '.kasya-aov-cart__payday-note { display: block; color: var(--kasya-aov-cart-muted, #6f6f6f); font-size: 10.5px; font-weight: 600; margin-top: 2px; white-space: normal; }'
  ].join('\n');
  document.head.appendChild(style);

  function paydayApplied(cart) {
    return ((cart && cart.items) || []).some(function (item) {
      var allocations = item.line_level_discount_allocations || item.discount_allocations || [];
      return allocations.some(function (allocation) {
        var app = allocation.discount_application || {};
        var label = [app.title, app.description, app.key].join(' ').toLowerCase();
        return Number(allocation.amount) > 0 && label.indexOf(KEYWORD) !== -1;
      });
    });
  }

  function applyGuard(drawer, cart) {
    var active = paydayApplied(cart);
    drawer.classList.toggle('kasya-aov-cart--payday-applied', active);
    if (!active) return;

    var subtotal = typeof drawer.getCartDisplaySubtotal === 'function'
      ? drawer.getCartDisplaySubtotal(cart)
      : Number(cart.items_subtotal_price) || 0;

    var progress = drawer.querySelector('[data-kasya-aov-cart-progress]');
    if (progress) {
      progress.style.width = Math.min(subtotal, FREE_SHIPPING_CENTS) / DISCOUNT_CENTS * 100 + '%';
    }
    drawer.classList.remove('kasya-aov-cart--discount-unlocked');

    if (subtotal < FREE_SHIPPING_CENTS) return;
    var copy = drawer.querySelector('[data-kasya-aov-cart-progress-copy]');
    if (!copy) return;
    copy.textContent = HEADLINE;
    var note = document.createElement('span');
    note.className = 'kasya-aov-cart__payday-note';
    note.textContent = NOTE;
    copy.appendChild(note);
  }

  customElements.whenDefined('kasya-aov-cart').then(function () {
    var Cart = customElements.get('kasya-aov-cart');
    if (!Cart || typeof Cart.prototype.renderOfferProgress !== 'function' || Cart.prototype.__paydayGuarded) return;
    Cart.prototype.__paydayGuarded = true;

    var original = Cart.prototype.renderOfferProgress;
    Cart.prototype.renderOfferProgress = function (cart) {
      var result = original.apply(this, arguments);
      try {
        applyGuard(this, cart);
      } catch (error) {
        console.warn('[Payday AOV guard]', error);
      }
      return result;
    };

    document.querySelectorAll('kasya-aov-cart').forEach(function (drawer) {
      if (drawer.cart) drawer.renderOfferProgress(drawer.cart);
    });
  });
})();
